<template>
<!-- 费用明细 -->
  <div class="buffet-total-detail">
    <div v-if="showBargaining.length > 0">合计费用: <span class="orangeColor">待议价</span></div>
    <div class="buffet-total-detail-box"  v-if="showBargaining.length == 0">
      <div class="buffet_total_item" v-for="item in buffetList" :key="item.index">
        <div class="buffet_total_item_top">
          <div class="buffet_total_title">
            <span class="buffet_total_title_name" v-if="item.sampleName === '全局问题'">{{dataForm.equipmentName}}</span>
            <span class="buffet_total_title_name" v-else-if="item.sampleName == '实验需求' || item.sampleName == '优惠费用'">{{item.sampleName}}</span>
            <span class="buffet_total_title_name" v-else>{{item.sampleName}}组样品</span>
            <span v-if="item.sampleName !== '全局问题' && item.sampleName !== '实验需求' && item.sampleName !== '优惠费用'">样品数量：{{item.specimenNum ? item.specimenNum : 0}}</span>
          </div>
          <!-- <div class="buffet_total_title" v-else>
            <span class="buffet_total_title_name">全局问题</span>
          </div> -->
          <div class="buffet_total_item_sum">
            <!-- ¥{{item.totalMomey ? item.totalMomey : 0}} -->
          </div>
        </div>
        <div v-for="i in item.subChargeVOList" :key="i.index">
          <div class="buffet_total_item_top" v-if="i.totalPrice || i.buffValue == '客户优惠'">
            <div class="buffet_total_title">
              <span>{{i.buffName}}：</span>
              <span style="color: #666666;font-size: 26rpx;padding-left: 10px;">{{i.buffValue}}</span>
              <!-- <span>{{i.showFieldName ? i.showFieldName : i.fieIdName}}</span> -->
            </div>
            <div>
              <span v-if="!['赠送金','优惠券','个人折扣', '团队折扣'].includes(i.buffName)">¥</span>
              {{Number(i.totalPrice).toFixed(2) == 'NaN' ? i.totalPrice :  Number(i.totalPrice).toFixed(2)}}
              <!-- <span v-if="i.buffName == '个人折扣'">¥</span>{{i.buffValue}} -->
              <!-- <span
                v-if="i.calculateWay == 1 || i.fieIdType == 10"
              >*{{item.specimenNum ? item.specimenNum : 0}}</span> -->
              <span
                v-if="i.calculateWay == 2 && dataForm.isCloudScene == 1"
              >*{{i.appointHours || 0}}h</span>
            </div>
          </div>
        </div>
        <!-- <div v-if="item.sampleName !== '实验需求' && Number(item.totalPrice) > 0">
          {{item.sampleName !== '优惠费用' ? '小计' : '合计'}}:{{item.sumText}}=¥{{item.totalPrice || 0}}
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    buffetList: {
      type: [Array, Object],
      default: () => []
    },
    dataForm: {
      type: [Array, Object],
      default: () => {}
    },
    //是否从列表进来的支付页面
    listOrderPay: {
      type: Boolean,
      default: false
    },
    showBargaining: {
      type: [Object,Array],
      default: ()=> []
    }
  },
  data(){
    return{
      list: []
    }
  },
  watch:{
    buffetList:{
      handler(val){
        this.init(val)
      }
    }
  },
  methods: {
    init(val){
      if(!this.listOrderPay){
        val = this.$orderUtils.convertBuffList(val)
        this.$forceUpdate()
      }
      this.$forceUpdate()
    }
  }
};
</script>
<style scoped>
.buffet-total-detail {
  width: 500px;
  max-height: 400px;
  overflow-y: auto;
  bottom: 80px;
}
.buffet_total_item_top {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  line-height: 40px;
}
.buffet_total_title_name {
  font-weight: 500;
  font-size: 16px;
  margin-right: 20px;
}
.buffet_total_item_sum {
  font-weight: 500;
  font-size: 16px;
  color: #4d6ffe;
}
</style>